<template>
  <b-navbar toggleable="lg" fixed="top">

    <div class="container">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <a :href="homepageUrl">
        <img class="header__logo-image" src="~assets/img/logo-header.png">
      </a>
      <a href="http://www.ttalliance.com/">
        <img class="header__logo-image header__logo-image--brand" src="~assets/img/logo-transformation-alliance.jpg">
      </a>

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav class="ml-auto">
          <b-nav-item @click="scrollToSection('#home')" href="#">Q5 Home</b-nav-item>
          <b-nav-item @click="scrollToSection('#how-it-works')" href="#">How it works</b-nav-item>
          <b-nav-item @click="scrollToSection('#benefits')" href="#">Benefits</b-nav-item>
          <b-nav-item @click="scrollToSection('#success-stories')" href="#">Success Stories</b-nav-item>
          <b-nav-item @click="scrollToSection('#contact')" href="#">Contact</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </div>

  </b-navbar>
</template>

<script>
export default {
  data() {
    return {
      homepageUrl: process.env.HOMEPAGE,
    };
  },
  methods: {
    scrollToSection(element) {
      if (this.$route.name === 'home') {
        this.$scrollTo(element);
      } else {
        this.$router.push({ name: 'home', params: { sectionScroll: element } });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Navbar/Main.vue